export const getAppConfig = () => (window as any).config;

export const isAppConfigValid = () => {
    const config = getAppConfig();

    return typeof config === 'object' && typeof config.api_url === 'string';
};
